import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { SolucionAccesible } from '../../core/services/soluciones.service';

/**
 * Tarjeta de una solución dentro del modal de cambio. Comparte la forma de
 * `app-workspace-option` en modo cambio: la tarjeta entera es el control y la
 * selección se marca al costado, sin botón propio.
 */
@Component({
  selector: 'app-solution-option',
  imports: [MatIconModule, TranslateModule],
  templateUrl: './solution-option.html',
  styleUrl: './solution-option.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SolutionOption {
  readonly solucion = input.required<SolucionAccesible>();
  readonly seleccionada = input(false);

  readonly elegir = output<SolucionAccesible>();

  /** Inicial para el caso, hoy el más común, de una solución sin imagen. */
  protected readonly inicial = computed(() => {
    const nombre = this.solucion().nombre?.trim();
    return nombre?.length ? nombre.charAt(0).toUpperCase() : 'S';
  });

  /** La que está abierta ahora no se ofrece como destino: ya se está ahí. */
  protected readonly esLaActual = computed(() => this.solucion().actual);

  /** Sin dirección no hay a dónde ir; se muestra, pero no navega. */
  protected readonly sinDestino = computed(() => !this.solucion().url && !this.esLaActual());

  protected alElegir(): void {
    this.elegir.emit(this.solucion());
  }
}
